import React, { useState, useRef } from 'react';
import { User, Phone, ShieldCheck, Contact2, Camera, Link, CheckCircle2, X } from 'lucide-react';

// ✅ IMPORTACIÓN CON RUTA ABSOLUTA
import { useAuth } from 'context/AuthContext';

const PerfilTutor = () => {
  const { user } = useAuth(); // Identidad real desde Firebase
  
  const [ineSubida, setIneSubida] = useState(false);
  const [previewIne, setPreviewIne] = useState(null);
  const fileInputRef = useRef(null);

  // --- ESTADO DEL FORMULARIO CON DATOS REALES ---
  const [perfil, setPerfil] = useState({
    nombre: user?.displayName || '',
    parentesco: 'Papá',
    whatsapp: user?.phone || ''
  });

  const handleActivarSubida = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewIne(reader.result);
        setIneSubida(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const removerIne = (e) => {
    e.stopPropagation();
    setPreviewIne(null);
    setIneSubida(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const guardarPerfilTotal = () => {
    if(!perfil.nombre || !perfil.whatsapp) {
      return alert("Nombre y WhatsApp son obligatorios para la seguridad.");
    }
    
    // Aquí se conectará con el updateDoc de Firebase en la v3.1
    alert("✅ Perfil de Seguridad Actualizado.\nLos datos han sido validados por el Core del Sistema.");
  };

  return (
    <div className="w-full max-w-4xl mx-auto space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500 pb-10 px-4 font-sans">
      
      <div className="text-center space-y-2">
        <h2 className="text-4xl font-black text-slate-900 italic tracking-tighter uppercase leading-none">Tu Perfil de Tutor</h2>
        <p className="text-slate-500 font-bold uppercase text-[10px] tracking-[0.2em] max-w-md mx-auto italic">
          La seguridad de los niños comienza con una identificación correcta.
        </p>
      </div>

      <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
        
        {/* SECCIÓN 1: DATOS PERSONALES */}
        <div className="bg-white p-8 rounded-[3rem] shadow-sm border-2 border-slate-50 space-y-6 text-left">
          <h3 className="text-[10px] font-black uppercase tracking-[0.3em] text-indigo-500 flex items-center gap-2 italic">
            <User size={14} /> Información Básica de contacto
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-4 italic">Nombre Completo</label>
              <input 
                type="text" 
                value={perfil.nombre}
                onChange={(e) => setPerfil({...perfil, nombre: e.target.value.toUpperCase()})}
                className="w-full p-5 bg-slate-50 rounded-2xl border-none font-bold text-slate-800 outline-none focus:ring-4 focus:ring-indigo-500/10 transition-all uppercase"
                placeholder="Nombre y Apellidos"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-4 italic">Parentesco</label>
                <select 
                  value={perfil.parentesco}
                  onChange={(e) => setPerfil({...perfil, parentesco: e.target.value})}
                  className="w-full p-5 bg-slate-50 rounded-2xl border-none font-bold text-slate-800 outline-none appearance-none cursor-pointer"
                >
                  <option>Papá</option>
                  <option>Mamá</option>
                  <option>Abuelo(a)</option>
                  <option>Tío(a)</option>
                  <option>Tutor Legal</option>
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-4 italic">WhatsApp</label>
                <div className="relative">
                  <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-indigo-400" size={16} />
                  <input 
                    type="tel" 
                    value={perfil.whatsapp}
                    onChange={(e) => setPerfil({...perfil, whatsapp: e.target.value})}
                    className="w-full pl-12 pr-4 p-5 bg-slate-50 rounded-2xl border-none font-bold text-slate-800 outline-none"
                    placeholder="10 dígitos"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECCIÓN 2: IDENTIFICACIÓN OFICIAL */}
        <div className="bg-white p-8 rounded-[3.5rem] shadow-sm border-2 border-slate-50 space-y-6 text-left">
          <div className="flex items-start justify-between">
            <div className="space-y-1">
              <h3 className="text-[10px] font-black uppercase tracking-[0.3em] text-emerald-500 flex items-center gap-2 italic">
                <Contact2 size={14} /> Seguridad Nivel 1
              </h3>
              <h4 className="text-2xl font-black text-slate-800 tracking-tighter leading-none italic uppercase">Validación de Identidad</h4>
            </div>
            <ShieldCheck size={40} className="text-emerald-500/20" />
          </div>

          <p className="text-[10px] font-bold text-slate-400 leading-relaxed italic uppercase tracking-widest">
            Captura el frente de tu identificación oficial para permitir el retiro de menores en recepción.
          </p>

          <input 
            type="file" 
            accept="image/*" 
            capture="environment" 
            ref={fileInputRef}
            onChange={handleFileChange}
            className="hidden"
          />

          <button 
            type="button"
            onClick={handleActivarSubida}
            className={`w-full min-h-[180px] rounded-[3rem] border-4 border-dashed transition-all flex flex-col items-center justify-center gap-3 relative overflow-hidden group ${
              ineSubida 
                ? 'bg-emerald-50 border-emerald-200' 
                : 'bg-slate-50 border-slate-200 hover:bg-white hover:border-indigo-200 hover:shadow-2xl shadow-inner'
            }`}
          >
            {ineSubida ? (
              <>
                <img src={previewIne} alt="INE Preview" className="absolute inset-0 w-full h-full object-cover opacity-40" />
                <div className="relative z-10 flex flex-col items-center">
                  <div className="w-16 h-16 bg-emerald-500 text-white rounded-full flex items-center justify-center shadow-xl animate-in zoom-in">
                    <CheckCircle2 size={32} />
                  </div>
                  <span className="font-black text-[10px] uppercase tracking-[0.2em] text-emerald-700 mt-4 bg-white/90 px-6 py-2 rounded-full backdrop-blur-sm shadow-sm">Documento Listo</span>
                  <button 
                    onClick={removerIne}
                    className="mt-4 text-[9px] font-black uppercase tracking-widest text-rose-500 hover:text-rose-700 bg-white/50 px-4 py-2 rounded-full border border-rose-100 transition-colors"
                  >
                    Eliminar y repetir
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="w-20 h-20 bg-white rounded-[2rem] flex items-center justify-center text-slate-400 shadow-inner group-hover:scale-110 transition-transform group-hover:text-indigo-500">
                  <Camera size={40} />
                </div>
                <div className="text-center">
                  <span className="font-black text-sm uppercase tracking-widest text-slate-700 block">Capturar identificación</span>
                  <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mt-1 block italic opacity-60">Click para activar cámara del iPad/Celular</span>
                </div>
              </>
            )}
          </button>
        </div>

        {/* SECCIÓN 3: VINCULACIÓN FAMILIAR */}
        <div className="bg-[#0A2440] p-10 rounded-[3.5rem] text-white space-y-6 relative overflow-hidden shadow-2xl border-b-8 border-indigo-600">
          <div className="absolute top-0 right-0 w-40 h-40 bg-indigo-500/10 rounded-full -mr-20 -mt-20 blur-3xl" />
          
          <div className="relative z-10 space-y-6 text-left">
            <div className="space-y-1">
               <h3 className="text-[10px] font-black uppercase tracking-[0.3em] text-amber-500 flex items-center gap-2 italic">
                 <Link size={14} /> Sincronización Familiar
               </h3>
               <h4 className="text-2xl font-black italic tracking-tighter uppercase leading-none text-white">¿Vincular con tu pareja?</h4>
            </div>
            
            <p className="text-[11px] font-bold text-slate-400 leading-relaxed max-w-sm italic uppercase tracking-widest">
              Ingresa el código familiar de 8 dígitos para unificar la administración de tus hijos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <input 
                type="text" 
                className="flex-1 p-5 bg-white/5 rounded-2xl border border-white/10 shadow-inner focus:ring-2 focus:ring-amber-500 transition-all outline-none text-2xl font-black text-center uppercase tracking-[0.4em] text-amber-400 placeholder:opacity-20"
                placeholder="FAM-0000"
                maxLength={8}
              />
              <button type="button" className="bg-amber-500 text-[#0A2440] px-8 py-5 rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl hover:bg-amber-400 transition-all active:scale-95">
                Vincular Cuentas
              </button>
            </div>
          </div>
        </div>

        {/* BOTÓN FINAL DE GUARDADO */}
        <button 
          type="button"
          onClick={guardarPerfilTotal}
          className="w-full bg-indigo-600 text-white p-8 rounded-[3rem] font-black text-lg uppercase tracking-[0.2em] shadow-2xl shadow-indigo-200 hover:bg-indigo-700 active:scale-95 transition-all flex items-center justify-center gap-4 border-b-8 border-indigo-800"
        >
          <ShieldCheck size={28} className="text-amber-400" />
          Finalizar y Guardar Seguridad
        </button>
      </form>
    </div>
  );
};

export default PerfilTutor;